module.exports = __webpack_public_path__ + "static/media/icon-placeholder.9c625891.svg";